// F1 Drivers Page
import React from 'react';
import { useF1Championship } from '../../hooks/useF1Championship';
import F1PageTemplate from '../../components/f1/F1PageTemplate';
import { driversConfig } from '../../components/f1/DriversComponent';
import DriversComponent from '../../components/f1/DriversComponent';

const F1DriversPage = () => {
  const { data } = useF1Championship();

  const stats = driversConfig.stats.map(stat => ({
    ...stat,
    value: typeof stat.value === 'function' ? stat.value(data) : stat.value
  }));

  return (
    <F1PageTemplate
      title={driversConfig.title}
      subtitle={driversConfig.subtitle}
      summary={driversConfig.summary}
      stats={stats}
    >
      <DriversComponent data={data} />
    </F1PageTemplate>
  );
};

export default F1DriversPage;
